import { CardContent, Button } from '@material-ui/core'
import React, { Component } from 'react'
import { Card } from 'react-bootstrap'

class DialogoDescargable extends Component {
  render () {
    const { camion, acoplado, handleClose } = this.props

    return (
      <div>
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
          </Card.Header>
          <CardContent style={{ width: '85%', margin: '0 auto', textAlign: 'center' }}>
            <h4>El camión <strong>{camion}</strong> y acoplado <strong>{acoplado}</strong></h4>
            <h4>¿ Son autodescargables ?</h4>
            <br />
            <div style={{ width: '60%', margin: '5% auto', display: 'flex', justifyContent: 'space-between' }}>
              <Button
                onClick={() => handleClose(true)}
                size='large'
                color='primary'
                variant='contained'
              >Si</Button>
              <Button
                onClick={() => handleClose(false)}
                size='large'
                color='primary'
                variant='contained'
              >No</Button>
            </div>
          </CardContent>
        </Card>
      </div>
    )
  }
}

export default DialogoDescargable
